import script from "./UiPerson.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPerson.vue?vue&type=script&setup=true&lang=js"

import "./UiPerson.vue?vue&type=style&index=0&id=0d363420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d363420"]])

export default __exports__